import request from '../../../api';

/**
 * A package's policy text, by the id a package on sale carries.
 *
 * A subscription arrives with its policy HTML inline
 * (`subscrPackagePolicyContent`); a package from the catalogue carries only a
 * `policyId`. Fetched only when the reader asks for it — on opening "السياسات"
 * on a card, or the checkout for a package that has one — so listing every
 * package costs no request per policy.
 *
 * Returns the HTML, or null when the id names nothing. Throws, per the layer
 * rule: the hook decides what a failure says.
 */
export const getPackagePolicy = (policyId) =>
    request
        .get('/public/policy', { params: { policyId } })
        .then((res) => res.data.data?.[0]?.content ?? null);
